import { render, staticRenderFns } from "./CalendarTableBody.vue?vue&type=template&id=2395dfde&"
import script from "./CalendarTableBody.vue?vue&type=script&lang=js&"
export * from "./CalendarTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports